/**
 * Client-side sorting utility for applications
 * Used when dataset is small enough to sort in browser
 */

export const sortApplications = (applications, sortField, sortOrder) => {
  if (!applications || applications.length === 0) return [];
  
  const sorted = [...applications].sort((a, b) => {
    let aVal = a[sortField];
    let bVal = b[sortField];
    
    // Handle dates
    if (sortField === 'applicationDate') {
      aVal = new Date(aVal).getTime();
      bVal = new Date(bVal).getTime();
    }
    
    // Handle strings (case-insensitive)
    if (typeof aVal === 'string' && typeof bVal === 'string') {
      aVal = aVal.toLowerCase();
      bVal = bVal.toLowerCase();
    }
    
    // Handle null/undefined
    if (aVal == null && bVal == null) return 0;
    if (aVal == null) return 1;
    if (bVal == null) return -1;
    
    // Compare
    let comparison = 0;
    if (aVal < bVal) comparison = -1;
    if (aVal > bVal) comparison = 1;
    
    return sortOrder === 'asc' ? comparison : -comparison;
  });
  
  return sorted;
};

/**
 * Check if we should use client-side sorting
 * @param {number} totalCount - Total number of records
 * @param {number} threshold - Threshold for client-side sorting (default: 10)
 */
export const shouldUseClientSorting = (totalCount, threshold = 10) => {
  return totalCount > 0 && totalCount < threshold;
};
